if(!customElements.get('image-banner')){
    class ImageBanner extends HTMLElement {
        constructor(){
            super();

            this.animationType = this.dataset.animationType || 'none';
        }

        connectedCallback(){
            this.initializeParallax();
        }

        initializeParallax(){
            gsap.registerPlugin(ScrollTrigger);

            if(this.animationType === 'zoom-in-out'){
                this.zoomInOut();
            } 
        }

        zoomInOut(){
            const childElements = this.querySelectorAll('parallax-element-section');
            if(childElements.length === 0) return;

            const target = childElements[0];
            const triggerEl = target;

            gsap.set(target, { scale: 0.8, opacity: 0, transformOrigin: "center center" });

            gsap.timeline({
                scrollTrigger: {
                    trigger: triggerEl,
                    start: "top-=300 center",
                    end: "bottom+=300 center+=100",
                    scrub: 1.5,
                    // markers: true,
                    invalidateOnRefresh: true
                }
            })
            .to(target, { scale: 1, opacity: 1, ease: "none", duration: 0.5 }, 0)
            .to(target, { scale: 1, ease: "none", duration: 0.90 })
            .to(target, { scale: 1.2, opacity: 0, ease: "none", duration: 0.05 });
        }
    }

    customElements.define('image-banner', ImageBanner);
}